import { apiUri } from '@/constants/Constants';
import { client } from '@/utils/axios/axiosClient';
import { useQuery } from '@tanstack/react-query';
import { AllValues } from '@/utils/types/types.util';
import { CorePermissions } from '@/constants/permissions.constant';
import useAuthStore from '@/stores/authStore';
import { useUrlChecker } from '@/hooks/useUrlChecker';

type GetCorePermissionsResponse = {
  corePermissionStatus: AllValues<typeof CorePermissions>[];
};

export async function getCorePermissions(): Promise<GetCorePermissionsResponse> {
  const requestUrl = apiUri.getCorePermissions;
  const response = await client.get(requestUrl, {
    withCredentials: true,
  });

  return response.data;
}

export function useCorePermissions() {
  const accessToken = useAuthStore((state) => state.accessToken);
  const { isPublic } = useUrlChecker();

  const data = useQuery({
    queryKey: ['getCorePermissions'],
    queryFn: () => {
      return getCorePermissions();
    },
    enabled: Boolean(accessToken) && accessToken !== 'DefaultToken' && !isPublic,
  });

  return data;
}
